<template>
    <div id="page-camera-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-center">
                <div class="flex-grow">
                    <div class="vx-col md:w-1/4 sm:w-auto mr-4">
                        <v-select class="" v-model="selectedOrganization" :clearable="false"
                                  :options="organizationOptions">
                            <span slot="no-options">{{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </div>
                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                          v-model="searchQuery"
                          @input="updateSearchQuery" placeholder="Tìm kiếm..."/>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="cameraList"
                         :animateRows="true"
                         :pagination="true"
                         :localeText=" {noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                         :paginationPageSize="20"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"/>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import _enum from '../../../enum'

export default {
    components: {

        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActions,
    },
    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 100
                },
                {
                    headerName: 'Tổ chức',
                    field: 'organizationName',
                    width: 200,
                },
                {
                    headerName: 'Tên camera',
                    field: 'cameraName',
                    width: 150
                },
                {
                    headerName: 'Trạng thái',
                    field: 'displayCameraStatus',
                    width: 150
                },
                ,
                {
                    headerName: 'Trực tuyến',
                    field: 'displayStreamingStatus',
                    width: 100
                },
                {
                    headerName: 'Lưu trữ',
                    field: 'displayEnableRecordAsMp4',
                    width: 100
                },
                {
                    headerName: 'Link Stream',
                    field: 'streamUrl',
                    width: 150
                },
                {
                    headerName: 'Actions',
                    field: 'actions',
                    width: 120,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions,
            },
            cameraList: [],
            organizationOptions: [{value: null, label: 'Tất cả tổ chức'}],
            selectedOrganizationValue: null
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteCameraStatus'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_CAMERA_STATUS', false);
            }
        },
    },
    computed: {
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        selectedOrganization: {
            get() {
                return {
                    label: this.organizationString(this.selectedOrganizationValue),
                    value: this.selectedOrganizationValue
                }
            },
            set(obj) {
                this.selectedOrganizationValue = obj.value
                this.loadCameras()
            }
        }
    },
    methods: {
        organizationString(id) {
            let organization = this.organizationOptions.find(x => x.value === id);
            return (organization && organization.label) || 'Chưa xác định';
        },
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        addCamera() {
            this.$router.push('/admin/add-camera').catch(() => {
            })
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        async initScreen() {
            await this.loadOrganizations(),
                this.loadCameras()
        },
        loadCameras() {
            this.$vs.loading();
            let path = "/camera/admin/all";
            if (this.selectedOrganizationValue) {
                path = "/camera/admin/find-by-organization/" + this.selectedOrganizationValue;
            }

            this.$vs.loading();
            this.$crm.post(path).then((response) => {
                this.cameraList = response.data.map(item => {
                    let organization = this.organizationOptions.find(x => x.value == item.organizationId);
                    item.organizationName = organization && organization.label;
                    item.streamFormatName = _enum.convertValueToName(_enum.StreamFormat, item.streamFormat);
                    item.displayCameraStatus = item.cameraStatus == 1 ? "Hoạt động" : "Ngừng hoạt động";
                    item.displayStreamingStatus = item.evgCamera && item.evgCamera.streamingStatus ? "Có" : "Không";
                    item.displayEnableRecordAsMp4 = item.evgCamera && item.evgCamera.enableRecordAsMp4 ? "Có" : "Không";
                    return item;
                });
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        loadOrganizations() {
            return new Promise(resolve => {
                this.$vs.loading();
                this.$oauth.post("/organization/admin/all").then((response) => {
                    this.$vs.loading.close();
                    this.organizationOptions.push(...response.data.map(item => {
                        return {
                            value: item.id,
                            label: item.name
                        }
                    }));
                    resolve(true);
                });
            })
        }
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    }
}
</script>

<style scoped>

</style>
